module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_tachikawa-309a529afab735110b1cf68fa7f3ac7d.jpg";